/**
 * SalesSettingsHub — Page Paramètres Ventes unifiée avec tabs internes.
 *
 * 2 onglets pour tout ce qui configure la facturation :
 *   ┌─ Défauts        (TVA, IBAN, mentions légales, marges)
 *   └─ Numérotation   (préfixes, séquences, formats)
 */
import { useSearchParams } from "react-router-dom";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { SlidersHorizontal, Hash, Palette } from "lucide-react";
import SalesDefaultsSettings from "@/pages/SalesDefaultsSettings";
import NumberingSettings from "@/pages/NumberingSettings";
import SalesTemplateSettings from "@/pages/SalesTemplateSettings";

export default function SalesSettingsHub() {
  const [params, setParams] = useSearchParams();
  const tabParam = params.get("tab");
  const active = tabParam === "numbering" ? "numbering"
               : tabParam === "template"  ? "template"
               : "defaults";

  const setTab = (t) => {
    const p = new URLSearchParams(params);
    if (t === "defaults") p.delete("tab");
    else p.set("tab", t);
    setParams(p, { replace: true });
  };

  return (
    <div className="space-y-6" data-testid="sales-settings-hub">
      <div>
        <h1 className="text-3xl font-semibold tracking-tight text-slate-900"
            style={{ fontFamily: "Manrope, sans-serif" }}>
          Paramètres Ventes
        </h1>
        <p className="mt-1 text-sm text-slate-500">
          Configure la facturation par défaut, la numérotation légale et le modèle visuel de tes documents.
        </p>
      </div>

      <Tabs value={active} onValueChange={setTab}>
        <TabsList className="bg-slate-100 p-1 h-auto">
          <TabsTrigger value="defaults" data-testid="settings-tab-defaults"
                       className="data-[state=active]:bg-white data-[state=active]:shadow-sm gap-2 px-4 py-2">
            <SlidersHorizontal className="h-4 w-4" />
            Défauts
          </TabsTrigger>
          <TabsTrigger value="numbering" data-testid="settings-tab-numbering"
                       className="data-[state=active]:bg-white data-[state=active]:shadow-sm gap-2 px-4 py-2">
            <Hash className="h-4 w-4" />
            Numérotation
          </TabsTrigger>
          <TabsTrigger value="template" data-testid="settings-tab-template"
                       className="data-[state=active]:bg-white data-[state=active]:shadow-sm gap-2 px-4 py-2">
            <Palette className="h-4 w-4" />
            Modèle de document
          </TabsTrigger>
        </TabsList>

        <TabsContent value="defaults" className="mt-6">
          <SalesDefaultsSettings embedded />
        </TabsContent>
        <TabsContent value="numbering" className="mt-6">
          <NumberingSettings embedded />
        </TabsContent>
        <TabsContent value="template" className="mt-6">
          <SalesTemplateSettings embedded />
        </TabsContent>
      </Tabs>
    </div>
  );
}
